document.addEventListener( 'DOMContentLoaded', accordion );

export function accordion() {
	const accordionButtons = document.querySelectorAll( '.accordion-button' );

	accordionButtons.forEach( ( button ) => {
		button.addEventListener( 'click', function () {
			const target = document.querySelector(
				this.getAttribute( 'data-target' )
			);

			if ( target.classList.contains( 'show' ) ) {
				target.classList.remove( 'show' );
				target.style.maxHeight = null;
				this.classList.add( 'collapsed' );
				this.setAttribute( 'aria-expanded', 'false' );
			} else {
				target.classList.add( 'show' );
				// console.log( target.scrollHeight );

				target.style.maxHeight = target.scrollHeight + 'px';

				this.classList.remove( 'collapsed' );
				this.setAttribute( 'aria-expanded', 'true' );
			}
		} );
	} );
}
